import {createStylesParams} from '@wix/tpa-settings';
import {baseStylesParams, IStylesParams, StylesParamKeys} from '../../baseStylesParams';

const stylesParams: IStylesParams = {
  ...baseStylesParams,
};

export default createStylesParams<StylesParamKeys>(stylesParams);
